import axios from "axios";

// In production, use relative URL to work with any domain
const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api'
  : (process.env.REACT_APP_API_URL || "http://localhost:8000/api");

class GoogleService {
  // Get OAuth URL
  async getAuthUrl() {
    console.log("getAuthUrl");
    console.log(localStorage.getItem("token"));
    try {
      const response = await axios.get(`${API_URL}/google/auth/url`, {
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      });
      console.log("getAuthUrl", response.data.authUrl);
      return response.data.authUrl;
    } catch (error) {
      console.log("error", error);
      console.error("Error getting auth URL:", error);
      throw error;
    }
  }

  // Get connected Google accounts
  async getAccounts() {
    try {
      const response = await axios.get(`${API_URL}/google/accounts`, {
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching accounts:", error);
      throw error;
    }
  }

  // Disconnect Google account
  async disconnectAccount(accountId) {
    try {
      const response = await axios.delete(
        `${API_URL}/google/accounts/${accountId}`,
        {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error disconnecting account:", error);
      throw error;
    }
  }

  // Get calendar events
  async getCalendarEvents(accountId, options = {}) {
    try {
      const params = new URLSearchParams({
        accountId,
        ...options,
      });

      const response = await axios.get(
        `${API_URL}/google/calendar/events?${params}`,
        {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching calendar events:", error);
      throw error;
    }
  }

  // Create calendar event
  async createCalendarEvent(accountId, event) {
    try {
      const response = await axios.post(
        `${API_URL}/google/calendar/events`,
        {
          accountId,
          event,
        },
        {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating calendar event:", error);
      throw error;
    }
  }

  // Update calendar event
  async updateCalendarEvent(accountId, eventId, event) {
    try {
      const response = await axios.put(
        `${API_URL}/google/calendar/events/${eventId}`,
        {
          accountId,
          event,
        },
        {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating calendar event:", error);
      throw error;
    }
  }

  // Delete calendar event
  async deleteCalendarEvent(accountId, eventId) {
    try {
      const response = await axios.delete(
        `${API_URL}/google/calendar/events/${eventId}?accountId=${accountId}`,
        {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting calendar event:", error);
      throw error;
    }
  }
}

export default new GoogleService();
